/**
 * Quando o acionamento do portal tem que acontecer.
 *
 * Agendado: a janela marcada (`scheduled_for`/`scheduled_until`).
 * Emergencial: a previsão do contratante — `max_sla` vem em MINUTOS e conta a
 * partir da detecção.
 */
const hora = (iso) =>
  new Date(iso).toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit" });

const dataHora = (iso) =>
  new Date(iso).toLocaleString("pt-BR", {
    day: "2-digit",
    month: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  });

export function prazoDoAcionamento(det = {}) {
  if ((det.attendance_type || "").toUpperCase() === "SCHEDULED") {
    if (!det.scheduled_for) return "";
    const fim = det.scheduled_until ? ` até ${hora(det.scheduled_until)}` : "";
    return `${dataHora(det.scheduled_for)}${fim}`;
  }
  if (!det.max_sla) return "";
  if (!det.detected_at) return `previsão em ${det.max_sla} min`;
  const alvo = new Date(new Date(det.detected_at).getTime() + det.max_sla * 60000);
  return `previsão ${hora(alvo)} · ${det.max_sla} min`;
}
